<template>
    <div class="favorites-tools" ref="favTools" @click="toggleFavTools">

        <div class="favorites-btns">
            <a href="#" class="btn btn-orange request-my-favorites" @click.prevent="showRequest=true">{{ trans('talents.favorites.btn-request') }}</a>
            <a :href="'/favorites/pdf?selected='+modelIds" class="btn btn-orange download-my-favorites">{{ trans('talents.favorites.btn-download') }}</a>
            <a href="#" class="btn btn-black" style="color:#000;cursor:default">{{ trans('talents.favorites.btn-share') }}</a>
            <a href="#" @click.prevent="showConfirmDeleteAll = true" class="btn btn-black delete-my-favorites">{{ trans('talents.favorites.btn-delete') }}</a>
<!--            <a href="#" class="btnhare-my-favorites" style="background:#000;color:#000;">{{ trans('talents.favorites.btn-share') }}</a>-->
            <!--            <a href="#" class="btn btn-orange share-my-favorites" @click.prevent="showShare=true">{{ trans('talents.favorites.btn-share') }}</a>-->
        </div>
        <favorites-request v-if="showRequest"></favorites-request>
        <favorites-share v-if="showShare"></favorites-share>
        <favorites-confirm v-if="showConfirmDeleteFavorite"></favorites-confirm>
        <favorites-confirm-delete-all v-if="showConfirmDeleteAll"></favorites-confirm-delete-all>
    </div>
</template>
<script type='text/babel'>
    import {mapState} from 'vuex'
    import FavoritesRequest from './FavoritesRequest.vue'
    import FavoritesShare from './FavoritesShare.vue'
    import FavoritesConfirm from './FavoritesConfirm.vue'
    import FavoritesConfirmDeleteAll from './FavoritesConfirmDeleteAll.vue'

    export default {
        components: {
            FavoritesRequest,
            FavoritesShare,
            FavoritesConfirm,
            FavoritesConfirmDeleteAll,
        },
        data: function () {
            return {
                showRequest: false,
                showShare: false,
                showConfirmDeleteAll: false
            }
        },
        mounted() {
            this.$on('hideRequest', () => this.showRequest = false)
            this.$on('hideShare', () => this.showShare = false)
            this.$on('hideConfirmDeleteAll', () => this.showConfirmDeleteAll = false)
        },
        computed: {
            ...mapState(['showConfirmDeleteFavorite']),
            modelIds(){
                return _.join(_.values(this.favoritesIds[this.project]),",")
            }
            // ...mapState(['models']),
            // ...mapState(['favorites']),
            // ...mapState(['project']),
            // currentList() {
            //     return this.listName === 'favorite' ? this.favorites[this.project] : this.models //ADD IF IS THEN FAVORITES
            // },
        },
        watch: {},
        methods: {
            deleteAllFavorites(){

            },
            toggleFavTools(){
              this.$refs.favTools.classList.toggle('active')
            }
        },
    };
</script>
